import { assign, Machine } from "xstate";
import { PAReviewModule } from "../../../../../store/modules/paReview.module";
const clientReviewMachines = Machine({
    id: "ClientReviewMachine",
    context: {
        tenantId: "",
        clientAssignmentId: "",
    },
    initial: "idle",
    states: {
        idle: {
            tags: "loading",
            on: {
                INITIALIZE: {
                    target: "initialize",
                    actions: "assignValuesToContext",
                },
            },
        },
        initialize: {
            tags: "loading",
            always: { target: "gettingClientReviews" },
        },
        gettingClientReviews: {
            tags: "loading",
            invoke: {
                id: "gettingClientReviews",
                src: (context, event) => {
                    return PAReviewModule.GetCycleReviewDetailsForClient({ tenantId: context.tenantId, clientAssignmentId: context.clientAssignmentId });
                },
                onDone: { target: "loadedClientReviews", actions: "storeTenantId" },
                onError: { target: "serviceUnavailable" },
            },
        },
        loadedClientReviews: {
            on: {
                INITIALIZE: {
                    target: "initialize",
                    actions: "assignValuesToContext",
                },
                DOWNLOAD_PDF: {
                    target: "downLoadPreviousPdf",
                },
            },
        },
        downLoadPreviousPdf: {
            tags: "download",
            invoke: {
                id: "downLoadPreviousPdf",
                src: (context, event) => {
                    return PAReviewModule.GeneratePAReviewPDF(event.previousReviewId);
                },
                onDone: { target: "downloadingReview" },
                onError: { target: "serviceUnavailable" },
            },
        },
        downloadingReview: {
            tags: "download",
            always: { target: "loadedClientReviews", actions: "downloadReviewPdf" },
        },
        serviceUnavailable: {},
    },
}, {
    guards: {},
    actions: {
        storeTenantId: assign((context, event) => {
            localStorage.setItem("tenantId", context.tenantId);
            return context;
        }),
        assignValuesToContext: assign({
            clientAssignmentId: (context, event) => event.clientAssignmentId,
            tenantId: (context, event) => event.tenantId,
        }),
        downloadReviewPdf: () => {
            const employeeName = PAReviewModule.clientReview.paCycleReviewClientAssignments.find((x) => x.previousPaReviewId == PAReviewModule.reviewId).employeeName;
            const previousCycleName = PAReviewModule.clientReview.paCycleReviewClientAssignments.find((x) => x.previousPaReviewId == PAReviewModule.reviewId).previousCycleName;
            const blob = new Blob([PAReviewModule.pdfData], { type: "application/pdf" });
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            document.body.appendChild(link);
            const fileName = `${"[" + "" + employeeName + "]" + "-" + previousCycleName}`;
            link.download = `${fileName}.pdf`;
            link.click();
        },
    },
    services: {},
});
export default clientReviewMachines;
